import { Link } from 'react-router-dom'

const FOOTER_COLS = [
  {
    title: 'Producto',
    links: [
      { label: 'Funcionalidades', href: '#funcionalidades', internal: false },
      { label: 'Cómo funciona', href: '#como-funciona', internal: false },
      { label: 'Precios', href: '#precios', internal: false },
    ],
  },
  {
    title: 'Soporte',
    links: [
      {
        label: 'Status en vivo ↗',
        href: 'https://status.thallein.com/status/guioncreator',
        internal: false,
        external: true,
      },
      {
        label: 'Contacto',
        href: 'mailto:support@guioncreator.com',
        internal: false,
      },
      {
        label: 'Reembolsos',
        href: 'mailto:refunds@guioncreator.com',
        internal: false,
      },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Política de reembolso', to: '/refund-policy', internal: true },
      { label: 'Privacidad', to: '/privacy', internal: true, disabled: true },
      { label: 'Términos', to: '/terms', internal: true, disabled: true },
    ],
  },
]

const cx = 'max-w-[1100px] mx-auto px-5 sm:px-8'
const linkClass =
  'font-sans text-[13px] text-ds-muted no-underline hover:text-ds-text transition-colors duration-150'

function FooterLink({ link }) {
  if (link.disabled) {
    return (
      <span
        className="font-sans text-[13px] text-ds-border-mid cursor-not-allowed"
        title="Próximamente"
      >
        {link.label}
      </span>
    )
  }
  if (link.internal) {
    return (
      <Link to={link.to} className={linkClass}>
        {link.label}
      </Link>
    )
  }
  if (link.external) {
    return (
      <a href={link.href} target="_blank" rel="noopener noreferrer" className={linkClass}>
        {link.label}
      </a>
    )
  }
  return (
    <a href={link.href} className={linkClass}>
      {link.label}
    </a>
  )
}

export function Footer() {
  return (
    <footer className="bg-[#080808] pt-16">
      <div className={cx}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-12 pb-16 border-b border-ds-border">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-7 h-7 bg-ds-red rounded-sharp flex items-center justify-center flex-shrink-0">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path
                    d="M1.5 3.2L6.5 1L11.5 3.2V6.5C11.5 9.5 6.5 12 6.5 12C6.5 12 1.5 9.5 1.5 6.5V3.2Z"
                    fill="white"
                    opacity="0.9"
                  />
                </svg>
              </div>
              <span className="font-display font-black text-[14px] tracking-[0.04em] uppercase text-ds-text">
                GuionCreator
              </span>
            </div>
            <p className="font-sans text-[13px] text-ds-muted leading-[1.65] max-w-[260px]">
              Guiones que suenan a ti, no a ChatGPT. Editor de guiones para creadores de YouTube.
            </p>
            <div className="mt-6">
              <p className="font-display font-bold text-label tracking-[0.14em] uppercase text-ds-muted mb-2.5">
                Para quién es
              </p>
              <p className="font-sans text-[12px] text-ds-muted leading-[1.7] max-w-[260px]">
                Creadores de 5k a 100k suscriptores que quieren publicar con más consistencia sin
                perder su voz.
              </p>
            </div>
          </div>

          {FOOTER_COLS.map(({ title, links }) => (
            <div key={title}>
              <p className="font-display font-bold text-label tracking-label uppercase text-ds-muted mb-5">
                {title}
              </p>
              <ul className="list-none p-0 m-0 flex flex-col gap-2.5">
                {links.map(link => (
                  <li key={link.label}>
                    <FooterLink link={link} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-7 flex items-center justify-between flex-wrap gap-4">
          <p className="font-sans text-[12px] text-ds-muted">
            © 2026 GuionCreator · Hecho en España
          </p>
          <div className="flex items-center gap-4 flex-wrap">
            <Link
              to="/refund-policy"
              className="font-sans text-[12px] text-ds-muted no-underline hover:text-ds-text transition-colors"
            >
              Reembolsos
            </Link>
            <span className="text-ds-border-mid">·</span>
            <a
              href="https://status.thallein.com/status/guioncreator"
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-[12px] text-ds-muted no-underline hover:text-ds-text transition-colors"
            >
              Status
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
